export default __webpack_public_path__ + "d272f75f3b81ce12a810c3e088a3dfff.png";